export const BELOTE_TRICKS_PER_HAND = 8;
export const BELOTE_MIN_BID = 80;
export const BELOTE_MAX_BID = 160;
export const BELOTE_CAPOT_VALUE = 250;
export function beloteDefaults(variant) {
    return variant === 'coinche'
        ? { variant, target: 1000, declarations: true, allowPissette: true, roundScores: true }
        : { variant, target: 501, declarations: true, allowPissette: false, roundScores: false };
}
export const DEFAULT_BELOTE_CONFIG = beloteDefaults('classic');
/** Partial, forgiving merge, the same contract as the other games: the
 *  defaults come from the variant, so `{ variant: 'coinche' }` alone is a
 *  complete Coinche table. */
export function validateBeloteConfig(raw) {
    if (raw === undefined || raw === null)
        return { ok: true, config: DEFAULT_BELOTE_CONFIG };
    if (typeof raw !== 'object')
        return { ok: false, error: 'config must be an object' };
    const r = raw;
    if (r.variant !== undefined && r.variant !== 'classic' && r.variant !== 'coinche') {
        return { ok: false, error: "variant must be one of 'classic' | 'coinche'" };
    }
    const variant = r.variant ?? 'classic';
    const out = { ...beloteDefaults(variant) };
    const errors = [];
    if (r.target !== undefined) {
        const v = r.target;
        if (typeof v !== 'number' || !Number.isInteger(v) || v < 100 || v > 5000) {
            errors.push('target must be an integer in [100, 5000]');
        }
        else
            out.target = v;
    }
    for (const key of ['declarations', 'allowPissette', 'roundScores']) {
        if (r[key] === undefined)
            continue;
        if (typeof r[key] !== 'boolean')
            errors.push(`${key} must be a boolean`);
        else
            out[key] = r[key];
    }
    if (variant === 'coinche' && out.declarations === false) {
        errors.push('Coinche is always played with declarations');
    }
    if (errors.length > 0)
        return { ok: false, error: errors.join('; ') };
    return { ok: true, config: out };
}
//# sourceMappingURL=config.js.map